import { DatePipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import {
  initialSharedModel,
  SharedModel,
} from "../../../sharedmodel/shared.model";
import { CdkDragDrop } from "@angular/cdk/drag-drop";

@Component({
  selector: "app-gis-data-table",
  templateUrl: "./gis-data-table.component.html",
  styleUrls: ["./gis-data-table.component.scss"],
  providers: [DatePipe], // Add DatePipe as a provider
})
export class GisDataTableComponent implements OnInit {
  @Input() enableDragDrop: boolean = false;
  @Output() dragDropped = new EventEmitter<CdkDragDrop<any[]>>();
  @Output() toggleStatus = new EventEmitter<{ logType: string, status: number, source?: any }>();
  @Input() data: any[] = [];
  @Input() columns: string[] = [];
  @Input() buttons: any = {}; // Input for buttons configuration
  @Input() getStatusClass: (status: any) => string;
  @Input() totalCount: number;
  @Input() isActionColumnClass: string;
  @Input() reportLoader: boolean = false;
  @Output() pageChange = new EventEmitter<any>();
  @Output() selectedRowsChange = new EventEmitter<any[]>(); // Output for selected rows
  @Input() isSorting: boolean = false; // Enable/disable sorting dynamically
  @Output() sortChange = new EventEmitter<{ field: string; order: string }>(); // Emit sorting event
  @Output() resetSortingEvent = new EventEmitter<void>(); // Emit reset sorting event
  sharedModel: SharedModel = { ...initialSharedModel };
  pageSizeOptions: number[] = [10, 25, 50, 100];
  defaultPageSize: number = 10;
  pageIndex: number = 0;
  sortOrder: string = 'asc'; // Sorting order (asc/desc)
  sortField: string = ''; // Currently sorted column
  // displayedColumns: string[] = [];// for drag and drop
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selectedRows: any[] = []; // Track selected rows
  constructor(private datePipe: DatePipe, private cdr: ChangeDetectorRef) {}
handleDrop(event: CdkDragDrop<any[]>) {
  this.dragDropped.emit(event);
}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.updateTableData(changes['data'].currentValue);
    }
  }
  ngOnInit(): void {
    this.updateTableData(this.data);
  }
  // Function to handle disabled state
  isButtonDisabled(element: any, buttonLabel: string): boolean {
    const status = element?.status;

    if (buttonLabel === "Accept Log") {
      // Enable 'Accept Log' button only for Accepted status
      return status !== 2;
    }

    if (buttonLabel === "Stop Process") {
      // Show 'Stop Process' button only for Validating status
      return status !== 3;
    }
    if (buttonLabel === "download") {
      // Enable the download button only for status 2
      return false//status !== 2;
    }
    if (buttonLabel === "Process Data") {
      // Enable the download button only for status 2
      return false//status !== 2;
    }
   if (buttonLabel === "Restart Process") {
  // Enable only when status is -1 or 7
  return !(status === -1 || status === 7);
}
  // If status is -1, only Restart Process should be enabled
  if (status === -1) {
    return true; // disable all other buttons
  }
    // Check based on status for other buttons
    if (status === 1) {
      // Status is valid, buttons should not be disabled
      return false;
    } else if (
      status === 2 ||
      status === -2 ||
      status === 0 ||
      status === 3 ||
      status === -3 ||
      status === 4
    ) {
      // Status is accepted, accept-invalid, invalid, or validating -> disable all buttons
      return true;
    }

    return false;
  }
// Add drop handler
  /**
   * Checks if a value is in a valid date format using regex.
   */
  isDate(value: any): boolean {
    // Regex to match date formats like "YYYY-MM-DD HH:MM:SS" or similar
    const dateRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/;
    return typeof value === "string" && dateRegex.test(value);
  }

  /**
   * Formats the value for display.
   * If the value is a date, it formats it to 'd MMM yyyy HH:mm:ss'.
   * Limits to 25 characters and adds ellipsis if needed.
   * Replaces null, undefined, or empty values with a dash.
   */
  formatDisplayValue(value: any): string {
    if (value === null || value === undefined || value === "") {
      return "--";
    }

    // Handle UTC string: "2025-05-26 04:17:59.333148"
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(value)) {
      // Convert to ISO string with 'Z' (UTC)
      const isoString = value.replace(" ", "T").split(".")[0] + "Z";
      const utcDate = new Date(isoString);

      // Convert to IST by adding 5.5 hours
      const istDate = new Date(utcDate.getTime() + (0 * 60 * 60 * 1000));

      return this.datePipe.transform(istDate, "d MMM yyyy HH:mm:ss") || "--";
    }

    // If it's a Date object (assume UTC)
    if (value instanceof Date) {
      const istDate = new Date(value.getTime() + (0 * 60 * 60 * 1000));
      return this.datePipe.transform(istDate, "d MMM yyyy HH:mm:ss") || "--";
    }

    // Fallback
    return value.toString().length > 20
      ? value.toString().slice(0, 20) + "..."
      : value.toString();
  }


  /**
   * Formats the value for the tooltip.
   * Replaces null, undefined, or empty values with a dash.
   */
  formatValue(value: any): string {
    return value === null || value === undefined || value === ""
      ? "--"
      : value.toString();
  }

  /**
   * Checks if a tooltip is needed based on the length of the value.
   */
  isTooltipNeeded(value: any): boolean {
    return value && value.toString().length > 20;
  }
  pageAction(e: PageEvent) {
    this.pageIndex = e.pageIndex;
    if (this.sharedModel.limit !== e.pageSize) {
      this.sharedModel.limit = e.pageSize;
      this.sharedModel.offset = 0;
      this.paginator.pageIndex = 0;
    } else {
      this.sharedModel.offset = this.pageIndex * e.pageSize;
    }
    const pagedetails = {
      limit: this.sharedModel.limit,
      offset: this.sharedModel.offset,

    };
    this.pageChange.emit(pagedetails);
    this.updateTableData(this.data);
  }
  // Function to handle individual row checkbox
  toggleRow(element: any): void {
    const index = this.selectedRows.indexOf(element);
    if (index === -1) {
      this.selectedRows.push(element);
    } else {
      this.selectedRows.splice(index, 1);
    }
    this.selectedRowsChange.emit(this.selectedRows);
  }

  // Function to check if a row is selected
  isRowSelected(element: any): boolean {
    return this.selectedRows.indexOf(element) !== -1;
  }

  // Function to handle "select all" checkbox in header
  toggleAllRows(event: any): void {
    if (event.checked) {
      // Select all rows in the current data
      this.selectedRows = [...this.data];
    } else {
      // Clear all selections
      this.selectedRows = [];
    }
    this.selectedRowsChange.emit(this.selectedRows);
  }

  // Check if all rows are selected
  isAllSelected(): boolean {
    return (
      this.data.length > 0 && this.selectedRows.length === this.data.length
    );
    // return this.selectedRows.length === this.data.length;
  }

  // Check if some rows are selected
  isSomeSelected(): boolean {
    // return this.selectedRows.length > 0 && this.selectedRows.length < this.data.length;
    return (
      this.data.length > 0 &&
      this.selectedRows.length > 0 &&
      this.selectedRows.length < this.data.length
    );
  }

  updateTableData(newData: any[]): void {
    this.data = Array.isArray(newData) ? newData : [];
    this.selectedRows = []; // Clear all selections
    this.selectedRowsChange.emit(this.selectedRows); // Notify changes
    this.cdr.detectChanges(); // Ensure UI updates are applied
  }
  resetCheckboxState(): void {
    // Uncheck the "Select All" checkbox by clearing selectedRows
    this.selectedRows = [];
    this.selectedRowsChange.emit(this.selectedRows); // Notify changes
    this.cdr.detectChanges(); // Ensure UI updates
  }

  updateToggleStatus(element: any, event: any): void {
    console.log(element, "element");
    let ele = element

  // const logType = element?.log_type;
  // const status = event?.checked ? 1 : 0;

  // if (logType != null) {
  //   this.toggleStatus.emit({ logType, status, source: event.source });
  // }
    const status = event?.checked ? 1 : 0;

  // Check if element contains log_type key
  const hasLogTypeKey = Object.prototype.hasOwnProperty.call(element, 'log_type');
  const logType = element?.log_type;

  // CASE 1: log_type exists BUT must not be null
  if (hasLogTypeKey && logType != null) {
    this.toggleStatus.emit({
      logType,
      status,
      source: event?.source
    });
    return;
  }

  // CASE 2: log_type does NOT exist → pass full element
  this.toggleStatus.emit({
    logType: ele,
    status,
    source: event?.source
  });
}
onSort(event: { field: string, order: string }) {
  if (!this.isSorting) return;
  this.sortField = event.field;
  this.sortOrder = event.order;

  this.sortChange.emit({ field: this.sortField, order: this.sortOrder }); // Emit sorting event
}

resetSorting() {
  this.sortField = '';
  this.sortOrder = '';
  this.resetSortingEvent.emit(); // Emit reset sorting event
}
}
